"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./rangePicker.scss");
const react_range_picker_1 = __importDefault(require("react-range-picker"));
const core_1 = require("@material-ui/core");
const moment_1 = __importDefault(require("moment"));
const config_1 = require("../../utils/config");
const svgIcons_1 = require("../../../../svgIcons");
const RangePick = (props) => {
    const [activeRange, setActiveRange] = react_1.useState({ key: 0, value: 'Select Range' });
    const [calendarVisible, setVisible] = react_1.useState(false);
    const [dateRange, setDateRange] = react_1.useState({ from: '', to: '' });
    const [pureDateRange, setPureDateRange] = react_1.useState({ from: '', to: '' });
    const toggleCalendar = () => {
        setVisible(!calendarVisible);
    };
    const date_placeholder = react_1.createRef();
    // very bad code, but does the job for now
    const fixCalendarPosition = () => {
        const rect = date_placeholder.current.getBoundingClientRect();
        setTimeout(() => {
            const elem = document.querySelector("#__range-picker-container .calendar.visible");
            elem.style.top = `${(rect.top + rect.height + window.pageYOffset) + 10}px`;
            if (window.innerWidth <= 768) {
                elem.style.left = '50%';
                elem.style.marginRight = '-50%';
                elem.style.transform = 'translate(-50%, 0)';
                setTimeout(() => elem.style.visibility = 'visible', 200);
            }
            else {
                elem.style.left = `${rect.left - 2}px`;
            }
        }, 50);
    };
    const filterWrapper = document.querySelector('.filters-wrapper');
    filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.addEventListener('scroll', () => {
        calendarVisible && toggleCalendar();
    });
    react_1.useEffect(() => {
        if (props.filterReseted) {
            setActiveRange({ key: 0, value: 'Select Range' });
            setDateRange({ from: '', to: '' });
            setPureDateRange({ from: '', to: '' });
        }
    }, [props.filterReseted]);
    const placeholder = ({ startDate, endDate }) => {
        return (react_1.default.createElement("div", { ref: date_placeholder, className: "fields-wrapper", onClick: fixCalendarPosition },
            react_1.default.createElement("div", { className: "placeholder" },
                react_1.default.createElement("p", { className: 'from' }, "From"),
                react_1.default.createElement("div", { className: `date-field ${dateRange.from ? 'date-field-filled' : ''}` },
                    " ",
                    dateRange.from || 'MM/DD/YY')),
            react_1.default.createElement("div", { className: 'short-line' }),
            react_1.default.createElement("div", { className: "placeholder" },
                react_1.default.createElement("p", { className: 'to' }, "To"),
                react_1.default.createElement("div", { className: `date-field ${dateRange.to ? 'date-field-filled' : ''}` }, dateRange.to || 'MM/DD/YY'))));
    };
    return (react_1.default.createElement("div", { id: "range-picker" },
        react_1.default.createElement(core_1.Box, { onClick: () => toggleCalendar(), className: `sub-title ${calendarVisible ? 'mb-15' : ''}` },
            react_1.default.createElement("p", null, activeRange.value),
            react_1.default.createElement(svgIcons_1.DropdownIcon, { className: `${calendarVisible ? 'open' : ''}`, fill: calendarVisible ? '#2EA0DC' : '' })),
        calendarVisible && react_1.default.createElement("div", { className: "range-picker-container" },
            react_1.default.createElement(react_range_picker_1.default, { defaultValue: { startDate: pureDateRange.from, endDate: pureDateRange.to }, placeholder: placeholder, closeOnSelect: true, onDateSelected: (f, l) => {
                    const from = moment_1.default(f).utc(true).format('YYYY-MM-DD');
                    const ui_from = moment_1.default(f).utc(true).format('MM/DD/YY');
                    setDateRange({ from: ui_from, to: '' });
                    if (l) {
                        const to = moment_1.default(l).utc(true).format('YYYY-MM-DD');
                        const ui_to = moment_1.default(l).utc(true).format('MM/DD/YY');
                        setDateRange({ from: ui_from, to: ui_to });
                        props.handleDateChange({ from: from, to: to });
                        setActiveRange({ key: null, value: `${ui_from} - ${ui_to}` });
                        setPureDateRange({ from: f, to: l });
                        setTimeout(() => toggleCalendar(), 1000);
                    }
                } }),
            react_1.default.createElement("div", { className: "buttons-group" }, config_1.rangeValues.map((el, i) => react_1.default.createElement("button", { key: i, onClick: () => {
                    props.handleDateChange({ from: el.from, to: el.to });
                    setActiveRange({ key: i, value: el.value });
                    setDateRange({ from: '', to: '' });
                    setPureDateRange({ from: '', to: '' });
                    setTimeout(() => toggleCalendar(), 1000);
                }, className: `v2-btn ${activeRange.key === i ? 'v2-btn-primary' : 'v2-btn-secondary'}` }, el.value))))));
};
exports.default = RangePick;
